import { useGraphQLQuery } from '@betterment/graphql';
import { useFeatureFlag } from '@betterment/shared-components';

import { ChatbotEligibilityDocument } from './graphql/query.chatbotEligibility.generated';

import { useIsAuthenticated } from '../features/authentication/authentication';
import { isMobileWebview } from '../Shared/user-agent-helpers';

export function useZendeskChatbotConfig(): boolean {
  const { enabled: isChatbotFeatureFlagEnabled } = useFeatureFlag({
    splitName: 'retail.chatbot_react_conversion_q4_2025_enabled',
    context: 'Chatbot',
  });

  const { enabled: isPremiumFeatureFlagEnabled } = useFeatureFlag({
    splitName: 'retail.chatbot_for_premium_q4_2025_enabled',
    context: 'Chatbot',
  });

  const isAuthenticated = useIsAuthenticated();
  const { data, loading } = useGraphQLQuery(ChatbotEligibilityDocument, {
    skip: !isAuthenticated,
    fetchPolicy: 'cache-first',
    throwOnError: false,
  });

  const isPremiumAdvised = data?.advisor?.__typename === 'PremiumAdvisor';
  const isInstitutionallyAdvised = data?.advisor?.__typename === 'InstitutionalAdvisor';
  const isMobileWebviewUser = isMobileWebview();
  const isEligible = !loading && !isMobileWebviewUser && isAuthenticated && !isInstitutionallyAdvised;

  const isFeatureFlagsEnabled = isPremiumAdvised
    ? isChatbotFeatureFlagEnabled && isPremiumFeatureFlagEnabled
    : isChatbotFeatureFlagEnabled;

  return isFeatureFlagsEnabled && isEligible;
}
